import React from 'react';
import './Gallery.css';

const Gallery = () => {
  return (
    <section id="gallery" className="gallery">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Gallery</h2>
          <p className="section-subtitle">
            Content to be filled in later
          </p>
        </div>

        <div className="gallery-content">
          {/* Gallery content will be added later */}
        </div>
      </div>
    </section>
  );
};

export default Gallery;


